import { Route, Routes } from "react-router-dom";
import SiteNav from "./components/layout/SiteNav.jsx";
import ScrollToTop from "./components/layout/ScrollToTop.jsx";
import PageShell from "./components/layout/PageShell.jsx";
import ClientFooter from "./components/layout/ClientFooter.jsx";
import { Hero, LaunchStrip, HardwareSection, EventSection } from "./components/sections/HomeSections.jsx";
import { ContactSection, JournalSection } from "./components/sections/JournalContactSections.jsx";

function HomePage() {
  return (
    <>
      <Hero />
      <LaunchStrip />
      <HardwareSection />
      <EventSection />
      <JournalSection />
      <ContactSection />
    </>
  );
}

export default function App() {
  return (
    <main>
      <ScrollToTop />
      <SiteNav />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/hardware" element={<PageShell eyebrow="Hardware" title="First Run"><HardwareSection full /></PageShell>} />
        <Route path="/event" element={<PageShell eyebrow="Event Night" title="Fingerboard Event"><EventSection full /></PageShell>} />
        <Route path="/journal" element={<PageShell eyebrow="Field Notes" title="Journal"><JournalSection full /></PageShell>} />
        <Route path="/contact" element={<PageShell eyebrow="Drop List" title="Contact"><ContactSection /></PageShell>} />
      </Routes>
      <ClientFooter />
    </main>
  );
}
